export const uploadToCloudinary = async (file) => {
	const cloud_name = "du0db2bl9";
	const upload_preset = "wkmniiml";

	if (!(cloud_name && upload_preset)) {
		console.log("Invalid upload preset / cloud name");
		throw Error("Unable to upload image. Please try again.");
	}

	const cloudinaryUrl = `https://api.cloudinary.com/v1_1/${cloud_name}/upload`;

	const formData = new FormData();

	formData.append("upload_preset", upload_preset);
	formData.append("folder", `hotel_booking`);
	formData.append("file", file);

	const response = await fetch(cloudinaryUrl, {
		body: formData,
		method: "POST",
		headers: { "X-Requested-With": "XMLHttpRequest" },
	}).then((res) => res.json());

	if (!response.secure_url)
		throw Error("Something went wrong. Please try again.");

	return {
		secure_url: response.secure_url,
		public_id: response.public_id
	};
};